import { render, staticRenderFns } from "./MiniProgramGuide.vue?vue&type=template&id=48974d7f&scoped=true&"
import script from "./MiniProgramGuide.vue?vue&type=script&lang=js&"
export * from "./MiniProgramGuide.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramGuide.vue?vue&type=style&index=0&id=48974d7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48974d7f",
  null
  
)

export default component.exports